<template>
    <video
        disableremoteplayback
        disablepictureinpicture
        muted
        playsinline
        preload="auto"
        x-webkit-airplay="deny"
        ref="videoPlayer"
        @loadedmetadata="logDuration"
        :currentTime.prop="videoProgress"
    >
        <source type="video/mp4" />
    </video>
</template>
<script>
export default {
    name: "VideoBlock",
    props: {
        scrollProgress: {
            type: Number,
            default: 0,
        },
    },
    data() {
        return {
            videoDuration: 0,
            videoProgress: 0,
            width: window.innerWidth,
        };
    },
    mounted() {
        this.resizeHandler();
    },
    methods: {
        logDuration: function () {
            this.videoDuration = this.backgroundVideo.duration;
        },
        resizeHandler: function () {
            this.width = window.innerWidth;
            this.resolveVideoURL();
        },
        resolveVideoURL: function () {
            if (this.width > 750) {
                this.backgroundVideo.setAttribute(
                    "src",
                    process.env.VUE_APP_API_BASE_URL +
                        "/media/" +
                        process.env.VUE_APP_THEME +
                        "/bgvideo_desktop.mp4#t=0.001"
                );
            } else {
                this.backgroundVideo.setAttribute(
                    "src",
                    process.env.VUE_APP_API_BASE_URL +
                        "/media/" +
                        process.env.VUE_APP_THEME +
                        "/bgvideo_mobile.mp4#t=0.001"
                );
            }
        },
    },
    computed: {
        backgroundVideo() {
            return this.$refs.videoPlayer;
        },
    },
    created() {
        window.addEventListener("resize", this.resizeHandler);
    },
    destroyed() {
        window.removeEventListener("resize", this.resizeHandler);
    },
    watch: {
        scrollProgress: {
            handler(val, oldVal) {
                this.$nextTick(() => {
                    if (val !== oldVal) {
                        if (this.videoDuration > 0) {
                            if (
                                this.backgroundVideo.currenttime !==
                                this.videoProgress
                            ) {
                                this.videoProgress =
                                    parseFloat(this.videoDuration * val) / 100;
                            }
                        } else {
                            this.videoProgress = 0;
                        }
                    }
                });
            },
            immediate: true,
        },
    },
};
</script>
<style scoped>
video {
    object-fit: cover;
    height: 100vh;
    width: 100vw;
}
</style>
